export default [
  //
  require('./video/video.json'),
  {
    tag: 'div',
    class: 'region-of-interest-container',
    children: [
      //
      require('./region-of-interest/region-of-interest.json'),
      require('./region-of-interest/slider/slider-controller.json'),
    ],
  },
  require('./controls/controls.json')
];
